import React, { Component } from 'react';
import propTypes from 'prop-types';
import moment from '~/Providers/Moment';
import mParticle, { ScreenViewEvent } from '~/Providers/mParticle';
import CustomDragLayer from '~/Components/Global/Stickers/CustomDragLayer';
import PageSplit from '~/Components/Layout/PageSplit/PageSplit';
import Month from '~/Containers/Pages/Calendar/MonthView/Month';
import Agenda from '~/Containers/Pages/Agenda/Agenda';
import Quote from '~/Containers/Global/Quote/Quote';
import ViewHeader from '~/Containers/Pages/Calendar/ViewHeader/ViewHeader';
import Stickers from '~/Containers/Global/Stickers/Stickers';
import { MONTH_TODO } from '~/Config/Checklists';
import { MONTH_VIEW, MONTH_VIEW_OUTSIDE } from '~/Config/CalendarViews';
import { DrawingProvider } from '~/Components/Global/Drawing/DrawingProvider';
import StickerDrop from '~/Containers/Global/Stickers/StickerDrop/StickerDrop';
import { DATE_FORMAT } from '~/Redux/Constants';
import { TaskList } from '../Tasks';

require('./Month.scss');

export default class MonthView extends Component {
  constructor() {
    super();
    this.dataLeft = {
      0: true,
      1: true,
      2: true,
      3: false,
      4: false,
      5: false,
      6: false,
    };
    this.dataRight = {
      0: false,
      1: false,
      2: false,
      3: true,
      4: true,
      5: true,
      6: true,
    };
  }

  componentDidMount = () => {
    const { match, setMonthType } = this.props;
    mParticle.logEvent(new ScreenViewEvent('Month View'));
    if (match.params.year || match.params.month) {
      const start = moment()
        .set('year', match.params.year)
        .set('month', match.params.month - 1);
      if (start.isValid()) {
        return setMonthType(start.startOf('month'));
      }
      return setMonthType(moment().startOf('month'));
    }
    return setMonthType(moment().startOf('month'));
  };

  render() {
    const { start, useMondayStart } = this.props;
    return (
      <Agenda>
        <CustomDragLayer />
        <DrawingProvider
          views={[MONTH_VIEW_OUTSIDE]}
          startDate={start
            .clone()
            .startOf('month')
            .format(DATE_FORMAT)}
          endDate={start
            .clone()
            .endOf('month')
            .format(DATE_FORMAT)}
        >
          <DrawingProvider
            views={[MONTH_VIEW]}
            startDate={start
              .clone()
              .startOf('month')
              .startOf('week')
              .format(DATE_FORMAT)}
            endDate={start
              .clone()
              .endOf('month')
              .startOf('week')
              .add(1, 'week')
              .format(DATE_FORMAT)}
          >
            <StickerDrop view={MONTH_VIEW_OUTSIDE} date={start.format(DATE_FORMAT)}>
              <PageSplit leftClassName="month-left-side" rightClassName="month-right-side">
                <div className="flex-row">
                  <div className="month-side-info tablet">
                    <ViewHeader />
                    <Quote showHeader={false} showFooter={false} />
                    <TaskList date={start} type={MONTH_TODO} header="GOALS" goalTaskWrapping />
                    <Stickers />
                  </div>
                  <div className="month-week-half">
                    <Month
                      days={this.dataLeft}
                      transition={this.transition}
                      time={start}
                      locale={moment.locale()}
                      useMondayStart={useMondayStart}
                    />
                  </div>
                </div>
                <div className="flex-row">
                  <div className="month-week-half">
                    <Month
                      days={this.dataRight}
                      transition={this.transition}
                      time={start}
                      locale={moment.locale()}
                      useMondayStart={useMondayStart}
                    />
                  </div>
                </div>
              </PageSplit>
            </StickerDrop>
          </DrawingProvider>
        </DrawingProvider>
      </Agenda>
    );
  }
}

MonthView.propTypes = {
  start: propTypes.object,
  match: propTypes.object,
  setMonthType: propTypes.func,
  useMondayStart: propTypes.any,
};
